interface BlueLabelProps {
  icon: JSX.Element;
  label: string;
  onClick: () => void;
}

const BlueLabel = ({ icon, label, onClick }: BlueLabelProps) => {
  return (
    <section
      className=" flex bg-blue bg-opacity-25 gap-3 pt-4 pb-4 pl-6 rounded-md items-center hover:cursor-pointer hover:bg-blue/40"
      onClick={onClick}
    >
      {icon}
      <label className="hover:cursor-pointer">{label}</label>
    </section>
  );
};

export default BlueLabel;
